
// @ts-nocheck
import locale_es_46json_6406214c from "#nuxt-i18n/6406214c";
import locale_en_45EN_46json_c0f07de3 from "#nuxt-i18n/c0f07de3";
import locale_de_45DE_46json_ac0bc2a8 from "#nuxt-i18n/ac0bc2a8";
import locale_it_45IT_46json_8c440d12 from "#nuxt-i18n/8c440d12";
import locale_fr_45FR_46json_9818091c from "#nuxt-i18n/9818091c";

export const localeCodes =  [
  "es",
  "en",
  "de",
  "it",
  "fr"
]

export const localeLoaders = {
  es: [
    {
      key: "locale_es_46json_6406214c",
      load: () => Promise.resolve(locale_es_46json_6406214c),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_45EN_46json_c0f07de3",
      load: () => Promise.resolve(locale_en_45EN_46json_c0f07de3),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_45DE_46json_ac0bc2a8",
      load: () => Promise.resolve(locale_de_45DE_46json_ac0bc2a8),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_45IT_46json_8c440d12",
      load: () => Promise.resolve(locale_it_45IT_46json_8c440d12),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_9818091c",
      load: () => Promise.resolve(locale_fr_45FR_46json_9818091c),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "es",
      country: "ES",
      name: "Español",
      language: "es",
      files: [
        {
          path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      country: "GB",
      name: "English",
      language: "en",
      files: [
        {
          path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/en-EN.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      country: "DE",
      name: "Deutsch",
      language: "de",
      files: [
        {
          path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/de-DE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      country: "IT",
      name: "Italiano",
      language: "it",
      files: [
        {
          path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/it-IT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      country: "FR",
      name: "Français",
      language: "fr",
      files: [
        {
          path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/fr-FR.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "../i18n/lang",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "es",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://byhours.mundojoven.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "es",
    country: "ES",
    name: "Español",
    language: "es",
    files: [
      {
        path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    country: "GB",
    name: "English",
    language: "en",
    files: [
      {
        path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/en-EN.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    country: "DE",
    name: "Deutsch",
    language: "de",
    files: [
      {
        path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/de-DE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    country: "IT",
    name: "Italiano",
    language: "it",
    files: [
      {
        path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/it-IT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    country: "FR",
    name: "Français",
    language: "fr",
    files: [
      {
        path: "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/i18n/lang/fr-FR.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/